module.exports = __webpack_public_path__ + "img/price-offer.bf7c4f2b.svg";